import { render, staticRenderFns } from "./ReceiveForms.vue?vue&type=template&id=a02d8d5c"
import script from "./ReceiveForms.vue?vue&type=script&lang=js"
export * from "./ReceiveForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports